<template>
  <div class="order_confirm_box container">
    <div class="order_confirm_content_box">

      <div class="min_tt_box">Order Information</div>

      <div class="good_list_box">
        <div class="good_item_box" v-for="(item, index) in goodList" :key="index">
          <img :src="item.flavorThumbnail" alt="" class="g_head">
          <div class="g_info_box">
            <div class="g_name">{{ item.name }}</div>
            <div class="g_attr">
              <p>Nicotine Content: <span>{{ goodsInfo.nicotineName }}</span></p>
              <p>Coil: <span>{{ goodsInfo.smokeType }}</span></p>
              <div class="num">X <span>{{ item.buyNum }}</span></div>
            </div>
          </div>
        </div>
      </div>

      <div class="min_tt_box">Delivery Information</div>

      <div class="noShow" @click="goChangeAddress" v-if="showR">
        <span class="t1">Select address</span>
        <img class="t2" src="@/assets/images1/45.png" alt="">
      </div>
      <div class="addr_out_box" v-else>
        <div class="a_name">
          {{ addressInfo.detail }}
        </div>
        <div class="a_other_info_box">
          <div class="left_box">
            <img src="@/assets/images1/46.png" alt="" class="icon">
            <span> {{ addressInfo.name }}</span>
            <img src="@/assets/images1/47.png" alt="" class="icon">
            <span> {{ addressInfo.phonenumber }}</span>
          </div>
          <div class="right_box">
            <img class="t2" @click="goChangeAddress" src="@/assets/images1/45.png" alt="">
          </div>
        </div>
      </div>

      <div class="min_tt_box">Payment Method</div>
      <div class="pay_out_box">
        <div class="line3_box paypal">
          <CRadio v-model="check" />
          <img src="@/assets/images1/53.png" alt="" class="icon1">
        </div>
      </div>

      <div class="count_out_box">
        <div class="price_out_box">
          <div class="red_price">Discount <span style="margin-left: 4px;">${{ Discount }}</span></div>
          <div class="min_price">Total</div>
          <div class="big_price">$78</div>
        </div>
        <el-button class="btn">Pay Now</el-button>
      </div>

    </div>
  </div>
</template>

<script>
import CRadio from "./CRadio.vue"

export default {
  components: { CRadio },
  data() {
    return {
      showR: true,
      addressInfo: {},
      Discount: '',
      check: false,
      goodList: [],
      goodsInfo: {},
    }
  },
  mounted() {


    let dataA = JSON.parse(localStorage.getItem("address"));
    if (dataA == null) {
      this.showR = true
    } else {
      this.showR = false;
      this.addressInfo = dataA;
    }
    console.warn(dataA, "data");
    this.goodsInfo = JSON.parse(sessionStorage.getItem("QUICK_BUY_DATA"));
    console.warn(this.goodsInfo, "goodsInfo")
    this.goodList = this.goodsInfo.falvorList || [];
  },
  //方法集合
  methods: {
    goChangeAddress() {
      this.$router.push({
        path: "Address",
        query: {
          type: 2
        }
      })
    }
  },
}
</script>

<style scoped lang="scss">
@import "./orderConfirm.scss";
</style>
